import deepEqual from 'deep-equal';
import { UserType } from 'pages/search/filters/user-type.enum';
import { SortDir } from 'pages/search/results/sort-dir.enum';
import { Database } from 'shared/database.enum';
import { SubIndex } from 'shared/sub-index.enum';
import CatalogueApi from 'api/query/catalogue/catalogue-api';
import { CancelToken } from 'axios';
import { ASBV } from './asbv/asbv';
import { DropdownItem } from '../../components/dropdown/dropdown-item';
import { Breeders } from './catalogue/catalogue';

const asbvFilter = 'asbvs';
const isPercentile = 'ispercentile';

export const addCustomASBVs = (asbvs: ASBV[]) => ({
  customASBVs: asbvs.map((a) => a.asbvId).toString(),
});

/**
   * Gets a querystring value as a string.
   *
   * - Values as arrays are mapped to a comma separated string.
   * - Default values are ignored.
   */
export const getParamValue = (filter: any, value: any, initial?: Map<any, any>) => {
  // Don't add querystring values for defaults
  if (deepEqual(value, initial?.get(filter)) || value.ignore) {
    return undefined;
  }

  // If a filter value is an object with an id use it, othewise use the value.
  let filterValue = value.id || value.value;
  if (Array.isArray(value)) {
    // Map an array to a comma separated string
    filterValue = value.map((v) => v.id).toString();
  }
  return filterValue;
};

/**
 * Addss the user type, database, traits and pagination to the params.
 */
export const getFilterParams = (dbType: Database, userType: UserType, subIndex?: SubIndex, pageNo?: number, pageSize?: number, sortBy?: string, sortDir?: SortDir, catalogueId?: number) => {
  const params = {
    dbType,
    userType,
    subIndex,
    pageSize,
    pageNumber: pageNo,
    sortBy,
    sortDir,
    catalogueId,
  };
  return params;
};

/**
 * Creates the params object for the asbvs and isPercentile .
 */
export const getParamsByAsbvFilter = (filters: Map<any, any>) => {
  const params: { [key: string]: String[] } = {};
  const filter: String[] = [];
  filters.forEach((value: any) => {
    filter.push(`${value.asbv},${value.min},${value.max}`);
  });

  params[asbvFilter] = filter;

  if (filters.size > 0) {
    params[isPercentile] = filters.values().next().value.isPercentile.toString();
  }

  return params;
};

/**
 * Creates the params object for the provided filter object.
 */
export const getParamsByFilter = (filters: Map<any, any>, initial?: Map<any, any>) => {
  const params: { [key: string]: string } = {};
  filters.forEach((value: any, filter: any) => {
    params[filter] = getParamValue(filter, value, initial);
  });
  return params;
};

export const getBreederAdmin = async (keyword?: string, token?: CancelToken) => {
  let breeders: Breeders[] = [];
  try {
    breeders = await CatalogueApi.getBreeder(keyword, token);
  } catch (e) {
    throw new Error(e);
  }
  const items: DropdownItem[] = breeders.map((b) => ({
    id: b.userId,
    value: `${b.firstName} ${b.lastName} / ${b.email}`,
  }));
  return items;
};
